import React, { useState } from "react";
import { Button } from "antd";
import { Link, useLocation } from "react-router-dom";

import Attendance from "components/attendance";
import { ATTENDANCE_ACTIONS } from "components/attendance/hooks";
import Icons from "../../icons";
import { Localize } from "components/service";
import { useMe } from "components/use-hooks";
import checkUser from "utils/check-user";
import UserHelpers from "components/user/helpers";

import "./more-menu.scss";

const { permission } = UserHelpers;
const { getUserPermissions } = checkUser;

const MoreMenu = () => {
    const location = useLocation();
    const { me } = useMe();
    const { isLimitedUser } = getUserPermissions(me);
    const hasSelectedExhibition = Boolean(me.eeCurrentId);
    const [ scanner, setScanner ] = useState({
        visible: false,
        action: ATTENDANCE_ACTIONS.CHECK_IN
    });

    const openScanner = (action) => {
        setScanner({
            visible: true,
            action
        });
    };

    const closeScanner = () => {
        setScanner((currentScanner) => ({
            ...currentScanner,
            visible: false
        }));
    };

    return (
        <>
            <ul className="more-menu">
                <li className="more-menu-attendance">
                    <div className="more-menu-attendance-actions">
                        <Button
                            type="primary"
                            className="check-in"
                            disabled={ !hasSelectedExhibition }
                            onClick={ () => openScanner(ATTENDANCE_ACTIONS.CHECK_IN) }
                        >
                            <Icons.Check type="circle" />
                            <Localize>ATTENDANCE.Button_CheckIn</Localize>
                        </Button>
                        <Button
                            type="default"
                            className="check-out"
                            disabled={ !hasSelectedExhibition }
                            onClick={ () => openScanner(ATTENDANCE_ACTIONS.CHECK_OUT) }
                        >
                            <Icons.Clock />
                            <Localize>ATTENDANCE.Button_CheckOut</Localize>
                        </Button>
                    </div>
                    {!hasSelectedExhibition && (
                        <div className="more-menu-attendance-hint">
                            <Localize>ATTENDANCE.SelectExhibitionFirst_Text</Localize>
                        </div>
                    )}
                </li>
                {isLimitedUser && (
                    <li>
                        <Link
                            to={ {
                                pathname: "/exhibitions",
                                state: { from: location.pathname }
                            } }
                        >
                            <Icons.List />
                            <Localize>MENUS.Label_SelectExhibition</Localize>
                        </Link>
                    </li>
                )}
                {!isLimitedUser && (
                    <>
                        <li>
                            <Link
                                to={ {
                                    pathname: "/more/expo-plan/",
                                    state: { from: location.pathname }
                                } }
                            >
                                <Icons.Plan />
                                <Localize>MENUS.Label_ExpoPlan</Localize>
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={ {
                                    pathname: "/more/halls-overview",
                                    state: { from: location.pathname }
                                } }
                            >
                                <Icons.Stands />
                                <Localize>MENUS.Label_HallsOverview</Localize>
                            </Link>
                        </li>
                    </>
                )}
                <li>
                    <Link to={ {
                        pathname: "/more/collect-graphics",
                        state: { from: location.pathname }
                    } }>
                        <Icons.Craft type="collect_graphics" />
                        <Localize>MENUS.Label_CollectGraphics</Localize>
                    </Link>
                </li>
                {!isLimitedUser && (
                    <>
                        {permission().has({ value: "view_damages" }) && (
                            <li>
                                <Link
                                    to={ {
                                        pathname: "/more/view-damages",
                                        state: { from: location.pathname }
                                    } }
                                >
                                    <Icons.Damages />
                                    <Localize>MENUS.Label_ViewDamages</Localize>
                                </Link>
                            </li>
                        )}
                        <li>
                            <Link to={ {
                                pathname: "/more/furnishing",
                                state: { from: location.pathname }
                            } }>
                                <Icons.Furnishing />
                                <Localize>MENUS.Label_FurnishingLeftovers</Localize>
                            </Link>
                        </li>
                        <li>
                            <Link to={ {
                                pathname: "/more/documents",
                                state: { from: location.pathname }
                            } }>
                                <Icons.Documents />
                                <Localize>MENUS.Label_Documents</Localize>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={ {
                                    pathname: "/more/help-and-imprint",
                                    state: { from: location.pathname }
                                } }
                            >
                                <Icons.Info />
                                <Localize>MENUS.Label_HelpImprint</Localize>
                            </Link>
                        </li>
                    </>
                )}
            </ul>
            <Attendance.Modals.Scanner
                visible={ scanner.visible }
                action={ scanner.action }
                eeId={ me.eeCurrentId }
                onClose={ closeScanner }
            />
        </>
    );
};

export default MoreMenu;
